import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const ContractHiringPage: React.FC = () => {
  return <ServicePageTemplate slug="contract-hiring" />;
};

export default ContractHiringPage;
